<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 哮天系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>资源列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="名称" style="width:300px"></el-input>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="建档" value="0"></el-option>
					<el-option key="1" label="采集中" value="1"></el-option>
					<el-option key="2" label="采集完成" value="2"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.level" placeholder="请选择级别">
					<el-option key="" label="请选择级别" value=""></el-option>
					<el-option v-for="item in levelKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="名称" width="300"></el-table-column>
				<el-table-column prop="level" label="级别" width="100">
					<template slot-scope="scope">
						{{scope.row.level==0?"普通":"重点"}}
					</template>
				</el-table-column>
				<el-table-column prop="source" label="采集网址"></el-table-column>
				<el-table-column prop="refreshTime" label="采集时间" width="160"></el-table-column>
				<el-table-column prop="status" label="状态" width="100">
					<template slot-scope="scope">
						{{scope.row.status==0?"建档":(scope.row.status==1?"采集中":"采集完成")}}
					</template>
				</el-table-column>
                <el-table-column label="操作" width="210" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
							class="handle-del mr10"
							v-if="controll['delete']"
							@click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-tickets"
                    class="handle-del mr10"
                    @click="handleInit"
					v-if="controll['init']"
                >初始化状态</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="添加新纪录" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="名称" prop="name">
					<el-input type=textarea v-model="form.name"  placeholder="多个公司名称用','分隔" :rows=5></el-input>
				</el-form-item>
				<el-form-item label="级别" prop="level">
					<el-select v-model="form.level" placeholder="请选择级别">
						<el-option v-for="item in levelKV" :key=item.key :label="item.value" :value=item.key></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="采集网址" prop="source" v-if="form.id">
					<el-input v-model="form.source"></el-input>
				</el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPotentialResourcesCompanyData, savePotentialResourcesCompany, getPotentialResourcesCompany, 
initPotentialResourcesCompany, deletePotentialResourcesCompany} from '../../../api/index';
export default {
    name: 'collect-companys',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			rules: {
                name: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
            },
			levelKV:[{"key":0, "value":"普通"}, {"key":1, "value":"重点"}]
        };
    },
    created() {
		this.controll = getControll('collect-companys');
        this.getData();
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPotentialResourcesCompanyData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResourcesCompany([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deletePotentialResourcesCompany(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.title = "添加新纪录";
			this.form = {};
			this.$set(this.form, "name", "");
			this.$set(this.form, "level", 0);
			this.editVisible = true;
		},
		handleEdit(index, row) {
			this.title = "修改";
			getPotentialResourcesCompany(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取企业数据失败！` + res.message);
				}
			})
		},
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.form.provideInventory == "") {
						this.form.provideInventory = false;
					}
					savePotentialResourcesCompany(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		handleInit() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要初始化的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要初始化选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					initPotentialResourcesCompany(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('初始化成功');
							this.getData();
						} else {
							this.$message.error(`初始化失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
